import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import NexposeConfigListing from './NexposeConfigListing'
import NexposeCredentialsForm from './NexposeCredentialsForm'

export default function NexposePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={NexposeCredentialsForm}
            PullConfigListingView={NexposeConfigListing}
        />
    )
}
